export default {
  getCompanyList: '/api/company/getCompanyList', // 公司列表
  getCompanyListToUid: '/api/company/getCompanyListToUid', // 获取用户绑定的公司列表
  editCompany: '/api/company/editCompany', // 修改公司信息
  addCompany: '/api/company/addCompany', // 添加公司
  delCompany: '/api/company/delCompany', // 删除公司

  //公司资料
  getCompanyInfoList: '/api/companyInfo/getCompanyInfoList', //获取公司资料列表table
  addCompanyInfo: '/api/companyInfo/addCompanyInfo', //添加公司资料
  editCompanyInfo: '/api/companyInfo/editCompanyInfo', //修改公司资料
  delCompanyInfo: '/api/companyInfo/delCompanyInfo', //删除公司资料
  //人员证书
  getPersonCertList: '/api/personCert/getPersonCertList', //获取人员证书列表table
  addPersonCert: '/api/personCert/addPersonCert', //添加人员证书
  editPersonCert: '/api/personCert/editPersonCert', //修改人员证书
  delPersonCert: '/api/personCert/delPersonCert', //删除人员证书
  getCompanyPersonnelList: '/api/companyPersonnel/getCompanyPersonnelList', //获取人员列表不分页
  //文书收发记录
  getDocumentLendVoucherList: '/api/documentLendVoucher/getDocumentLendVoucherList', //获取文书收发记录列表table
  addDocumentLendVoucher: '/api/documentLendVoucher/addDocumentLendVoucher', //添加文书收发记录
  editDocumentLendVoucher: '/api/documentLendVoucher/editDocumentLendVoucher', //修改文书收发记录
  getDocumentLendGoodsList: '/api/documentLendGoods/getDocumentLendGoodsList', //查询借出单附件详情
  getDocumentLendGoodsWithFiles: '/api/documentLendVoucher/getDocumentLendGoodsWithFiles', //查看借出单附件列表

  batchReturn: '/api/documentLendVoucher/batchReturn', //清单全部归还
  sectionReturn: '/api/documentLendGoods/batchReturn', //清单部分归还
  //企业资质
  getCompanyQualificationList: '/api/companyQualification/getCompanyQualificationList', //获取资质列表table
  addCompanyQualification: '/api/companyQualification/addCompanyQualification', //添加资质
  editCompanyQualification: '/api/companyQualification/editCompanyQualification', //修改资质
  delCompanyQualification: '/api/companyQualification/delCompanyQualification', //删除资质

  setCompanyLocalTax: '/api/company/setCompanyLocalTax', //设置税率
};
